<template>
  <div>
    <div v-if="selectedEvent.evaluation">
      <v-row class="align-center">
        <v-col class="pa-0 col-auto">
          <v-avatar size="40" color="primary">
            <span class="white--text text-h5">{{ firstTowLettersName(selectedEvent.employee_name.name) }}</span>
          </v-avatar>
        </v-col>
        <v-col>
          <div style="font-size:11px;font-weight:700;">{{ i18n.employee }}</div>
          <strong>{{ selectedEvent.employee_name.name }}</strong>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" class="pa-0 mb-md-2 mb-3">
          <div style="font-size:11px;font-weight:700;">{{ i18n.evaluation_appointment }}</div>
          <div class="body-1">
            <v-chip color="blue darken-1" dark small>
              {{ formatDateToCurrentLocale(selectedEvent.start)[0] }}
            </v-chip>
            <v-chip color="blue darken-1" dark class="ml-2" small>
              {{ formatDateToCurrentLocale(selectedEvent.start)[1] }}
            </v-chip>
          </div>
        </v-col>
        <v-col cols="12" md="6" class="pa-0 mb-md-2 mb-3">
          <div style="font-size:11px;font-weight:700;">{{ i18n.evaluation_update_date }}</div>
          <div class="body-1">{{ getFormat(selectedEvent.evaluation.updated_at) }}</div>
        </v-col>
        <v-col cols="12" md="6" class="pa-0 mb-md-2 mb-3">
          <div style="font-size:11px;font-weight:700;">{{ i18n.was_present }}</div>
          <div class="body-1">{{ selectedEvent.attended ? i18n.yes : i18n.no }}</div>
        </v-col>
      </v-row>
      <v-row v-if="selectedEvent.evaluation.note" class="mt-md-2 ">
        <v-col cols="12" class="pa-0">
          <div style="font-size:11px;font-weight:700;">{{ i18n.evaluation_note }}</div>
          <div class="body-1">
            {{ selectedEvent.evaluation.note }}
          </div>
        </v-col>
      </v-row>
      <v-row v-if="selectedEvent.evaluation.result" class="mt-2">
        <v-col col="12" class="pa-0">
          <div class="mb-1">
            <div style="font-size:11px;font-weight:700;">{{ i18n.evaluation_result }}</div>
          </div>
          <v-chip label small color="blue" dark>
            {{ selectedEvent.evaluation.result }}
          </v-chip>
        </v-col>
      </v-row>
    </div>
    <div v-else-if="selectedEvent.interview">
      <v-row class="align-center">
        <v-col class="pa-0 col-auto">
          <v-avatar size="40" color="primary">
            <span class="white--text text-h5">{{ firstTowLettersName(selectedEvent.employee_name.name) }}</span>
          </v-avatar>
        </v-col>
        <v-col>
          <div style="font-size:11px;font-weight:700;">{{ i18n.employee }}</div>
          <strong>{{ selectedEvent.employee_name.name }}</strong>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" class="pa-0 mb-md-2 mb-3">
          <div style="font-size:11px;font-weight:700;">{{ i18n.evaluation_appointment }}</div>
          <div>
            <v-chip color="blue darken-1" dark small>
              {{ formatDateToCurrentLocale(selectedEvent.start)[0] }}
            </v-chip>
            <v-chip color="blue darken-1" dark class="ml-2" small>
              {{ formatDateToCurrentLocale(selectedEvent.start)[1] }}
            </v-chip>
          </div>
        </v-col>
        <v-col cols="12" md="6" class="pa-0 mb-md-2 mb-3">
          <div style="font-size:11px;font-weight:700;">{{ i18n.interview_application }}</div>
          <div class="body-1">{{ selectedEvent.interview.application }}</div>
        </v-col>
        <v-col cols="12" md="6" class="pa-0 mb-md-2 mb-3">
          <div style="font-size:11px;font-weight:700;">{{ i18n.interview_information }}</div>
          <div class="body-1">{{ selectedEvent.interview.information }}</div>
        </v-col>
        <v-col cols="12" md="6" class="pa-0 mb-md-2 mb-3">
          <div style="font-size:11px;font-weight:700;">{{ i18n.evaluation_update_date }}</div>
          <div class="body-1">{{ getFormat(selectedEvent.interview.updated_at) }}</div>
        </v-col>
        <v-col cols="12" md="6" class="pa-0 mb-md-2 mb-3 mt-2">
          <div style="font-size:11px;font-weight:700;">{{ i18n.was_present }}</div>
          <div class="body-1">{{ selectedEvent.attended ? i18n.yes : i18n.no }}</div>
        </v-col>
        <v-col cols="12" md="6" class="pa-0 mb-md-0 mb-3 mt-2">
          <div style="font-size:11px;font-weight:700;">{{ i18n.interview_link }}</div>
          <div>
            <div class="body-1">{{ selectedEvent.interview.link }}</div>
            <div class="d-flex align-items-center mt-1">
              <v-btn
                dark  
                @click.prevent="clipboard(selectedEvent.interview.link)"
                color="indigo darken-1"
                x-small
              >
              {{ i18n.copy }}
              <v-icon size="14" class="ml-1">link</v-icon>
            </v-btn>
              <v-btn
                link
                :href="selectedEvent.interview.link"
                target="_blank"
                dark  
                color="blue darken-1"
                x-small
                class="ml-1"
              >
              {{ i18n.open}}
              <v-icon size="14" class="ml-1">open_in_new</v-icon>
            </v-btn>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="6" class="pa-0 mb-md-0 mb-3 mt-2">
          <div style="font-size:11px;font-weight:700;">{{ i18n.interview_status }}</div>
          <div>
            <v-chip small :color="getColorBasedOnInterviewStatus(selectedEvent.interview)">
              {{ !selectedEvent.interview.accepted && !selectedEvent.interview.rejected ? i18n.interview_pending : (interview.accepted ? i18n.interview_accepted : i18n.interview_rejected) }}
            </v-chip>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>


<script>
import { format } from 'timeago.js';

export default {
  props: ['selectedEvent', 'resource'],
	computed: {
		user() {
			return this.$store.state.user
		},
		language() {
			return this.$store.state.language
		},
		i18n() {
			return this.$store.state.i18n[this.$store.state.language]
		},
		arabic() {
			if (this.$store.state.language == 'ar') return true
		},
	},
  methods: {
    clipboard (str) {
      navigator.clipboard.writeText(str)
    },
    getColorBasedOnInterviewStatus(interview) {
      return !interview.accepted && !interview.rejected ? `warning` : (interview.accepted ? 'success' : 'red')
    },
		getFormat(d){
			return format(d)
		},
		formatDateToCurrentLocale(date) {
			let new_date = (new Date(date))
			return [
				new_date.toLocaleDateString(this.arabic ? 'ar' : 'en', {
					day: 'numeric',
					year: 'numeric',
					month: 'short',
				}),
				new_date.toLocaleTimeString(this.arabic ? 'ar' : 'en'),
			]
		},
		firstTowLettersName(name) {
			const split_names = name.split(" ")

			if (split_names.length == 0) return ""

			if (split_names.length > 1) return (split_names[0][0] + split_names[1][0]).toUpperCase()

			return (split_names[0][0] + split_names[0][1]).toUpperCase()
		},
  }
}
</script>